import React from 'react';
import {
  Snackbar,
  SnackbarContent,
  Slide,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

export default function PositionedSnackbar({ toast, setToast }) {
  // const [state, setState] = React.useState({
  //   open: toast.state,
  //   vertical: 'top',
  //   horizontal: 'center'
  // });
  //   const [open, setOpen] = React.useState(false);
  // const { vertical, horizontal, open } = state;

  // const handleClick = (newState) => () => {
  //   setState({ open: true, ...newState });
  // };

  const handleClose = () => {
    // setState({ ...state, open: false });
    setToast({ state: false, message: '' });
  };

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={toast.state}
        classes={{ root: `toastr-${toast.color}` }}
        onClose={handleClose}
        autoHideDuration={5000}
        // TransitionComponent={<Slide {...props} direction="left" />}
        // color="danger"
        // message={toast.message}
        // ContentProps={{ backgroundColor: 'red' }}
        // key={vertical + horizontal}
        // action={
        //   <IconButton
        //     aria-label="close"
        //     color="inherit"
        //     // className={classes.close}
        //     onClick={handleClose}>
        //     <CloseIcon />
        //   </IconButton>
        // }
      >
        <SnackbarContent
          message={toast.message}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              // className={classes.close}
              onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }
        />
      </Snackbar>
    </div>
  );
}
